import { computed } from 'vue'
import store from '@/store'
import { alert } from '@/alert'
import i18n from '@/i18n'

/**
 * mapIndoor store の action を利用するラッパーコンポーザブル
 * エラー時のアラート表示などを行う
 */
export const useMapIndoorStore = () => {
  /**
   * ビルを変更する
   * @param {IndoorBuilding} indoorBuilding ビルデータ
   */
  const changeIndoorBuilding = (indoorBuilding) => {
    // TODO:変更できない場合のメッセージ表示実装
    store.dispatch('mapIndoor/changeIndoorBuilding', indoorBuilding)
  }

  /**
   * ビル選択を解除する
   */
  const unselectedBuilding = () => {
    store.dispatch('mapIndoor/unselectedBuilding')
  }

  /**
   * 現在のフロアID
   * @type {ComputedRef.<number>}
   */
  const currentIndoorLevelId = computed(
    () => store.state.mapIndoor.activeIndoorLevelId
  )

  /**
   * アクティブなフロアIDを設定する
   * @param {number|null} indoorLevelId フロアID
   */
  const setActiveIndoorLevelId = (indoorLevelId) => {
    store.dispatch('mapIndoor/setActiveIndoorLevelId', indoorLevelId)

    // 実行後チェック
    // 不一致の場合は何らかの理由でフロアの変更ができないので失敗アラートを表示する
    if (currentIndoorLevelId.value !== indoorLevelId) {
      _showFailedToSetIndoorLevelToast()
    }
  }

  /**
   * フロア設定に失敗した旨のアラートを表示する
   */
  const _showFailedToSetIndoorLevelToast = () => {
    alert.fire({
      icon: 'error',
      title: i18n.t('useMapIndoorStore.message.error'),
      text: i18n.t('useMapIndoorStore.message.cannotChangeToIndoorLevel'),
    })
  }

  return {
    changeIndoorBuilding,
    unselectedBuilding,
    setActiveIndoorLevelId,
  }
}
